'use strict';

module.exports = {
    init: () => {
        const $body = $('body');

        $body.on('click', '.product-tile--amadeus .product-tile--amadeus__select-button', (e) => {
            let $item = $(e.currentTarget);
            let $tile = $item.closest('.product-tile--amadeus');

            if ($tile.length === 0) {
                return;
            }

            let amadeusData = $tile.data('amadeus');

            $body.trigger('amadeus:select', amadeusData);
        });
    }
};
